<script>
  import ValidationMessage from '../../../../components/form/ValidationMessage.vue'
  import Password from 'vue-password-strength-meter'
  import * as restfulService from '../../../../services/restfulService'
  import * as notifyService from '../../../../services/notifyService'
  import * as cepService from '../../../../services/cepService'
  import DataService from '../../../../services/dataService'
  import helperMixin from '../../../../../mixins/helper'
  import {required, requiredIf, minLength} from 'vuelidate/lib/validators'
  import {cloneDeep} from 'lodash'
  import moment from 'moment'
  import bus from '@utils/bus'

  export default {
    components: {ValidationMessage, Password},
    mixins: [helperMixin],
    props: ['registration'],
    data () {
      return {
        isLoadingData: true,
        isSubmitted: false,
        isSearchingCity: false,
        data: {
          sexo: 'M',
          fone_residencial: '',
          fone_celular: '',
          fone_recado: '',
          rg_numero: '',
          cpf: '',
          dt_nascimento: '',
          ref_naturalidade: '',
          ref_nacionalidade: '',
          ref_estado_civil: '',
          ref_raca: '',
          necessidades_especiais: [],
          nome_pai: '',
          nome_mae: '',
          link_lattes: '',
          ec_ref_cidade: '',
          ec_nome: '',
          ec_cpf_cnpj: '',
          ec_cep: '',
          ec_rua: '',
          ec_numero: '',
          ec_complemento: '',
          ec_bairro: ''
        },
        dependencies: {
          cities: [],
          special_needs: [],
          ethnicities: [],
          marital_status: [],
          countries: []
        }
      }
    },
    validations: {
      data: {
        sexo: {required},
        fone_celular: {required},
        dt_nascimento: {required},
        cpf: {
          required: requiredIf(function () {
            return !this.data.rg_numero
          }),
          minLength: minLength(14)
        },
        rg_numero: {
          required: requiredIf(function () {
            return !this.data.cpf
          })
        },
        nome_mae: {required},
        ref_nacionalidade: {required},
        ec_nome: {
          required: requiredIf(function () {
            return this.isOverEighteen
          })
        },
        ec_cpf_cnpj: {
          required: requiredIf(function () {
            return this.isOverEighteen
          })
        },
        ec_cep: {
          required: requiredIf(function () {
            return this.isOverEighteen
          })
        },
        ec_rua: {
          required: requiredIf(function () {
            return this.isOverEighteen
          })
        },
        ec_numero: {
          required: requiredIf(function () {
            return this.isOverEighteen
          })
        },
        ec_bairro: {
          required: requiredIf(function () {
            return this.isOverEighteen
          })
        },
        ec_ref_cidade: {
          required: requiredIf(function () {
            return this.isOverEighteen
          })
        }
      }
    },
    computed: {
      isOverEighteen: function () {
        return moment().diff(moment(this.data.dt_nascimento, 'YYYY-MM-DD'), 'years', false) < 18
      }
    },
    watch: {
      /**
       * Observa alterações no CEP para autocompletar os dados do endereço pela API do viacep
       */
      'data.ec_cep': function () {
        let cep = this.onlyNumbers(this.data.ec_cep)
        if (cep.length === 8) {
          bus.$emit('show-loader')
          cepService.get(cep)
            .then(data => {
              if (!data.hasOwnProperty('erro')) {
                this.data.ec_rua = data.logradouro
                this.data.ec_bairro = data.bairro
                this.onSearchCity(data.localidade).then(_ => {
                  this.data.ec_ref_cidade = this.dependencies.cities[0].id
                  if (!this.data.ec_numero) {
                    this.$refs.physicalDataNumero.focus()
                  }
                  bus.$emit('hide-loader')
                })
              }
            })
            .catch(() => {
              notifyService.warning({title: 'Atenção', message: 'Endereço não encontrado, verifique o CEP'})
              bus.$emit('hide-loader')
              console.log('error')
            })
        }
      }
    },
    mounted () {
      if (!this.registration) {
        this.$swal({
          title: 'Atenção',
          text: 'Você não pode acessar essa página diretamente',
          type: 'warning'
        })
        this.$router.push({name: 'registration.index'})
      } else {
        this.getDependencies().then(() => {
          // Recupera os dados da props: registration e atribui ao data do componente
          this.data = this.registration.physicalData.data

          // Caso o usuário possua o ref_naturalidade se busca na API a cidade relacionada
          // e adiciona a mesma no array de cidades
          if (this.data.ref_naturalidade) {
            this.getCity(this.data.ref_naturalidade).then(response => {
              this.dependencies.cities.splice(0)
              this.dependencies.cities.push(response)
            })
          }
          this.isLoadingData = false
        })
      }
    },
    methods: {
      /**
       * Buscas as dependencias na API
       * @returns {Promise<any>}
       */
      getDependencies () {
        return new Promise(resolve => {
          DataService.get([
            {domain: 'country'},
            {domain: 'marital_status'},
            {domain: 'special_needs'},
            {domain: 'ethnicity'}
          ]).then((result) => {
            this.dependencies = {...this.dependencies, ...result}
            resolve()
          })
        })
      },
      /**
       * Busca uma cidade na API/Segue
       * @param cityId
       * @returns {Promise<any>}
       */
      getCity (cityId) {
        return new Promise((resolve, reject) => {
          restfulService.get('city', null, cityId)
            .then((response) => {
              resolve(response)
            })
            .catch(e => {
              console.log(e)
              reject()
            })
        })
      },
      /**
       * Busca cidades na API/Segue
       * @param query
       * @returns {Promise<any>}
       */
      onSearchCity (query) {
        return new Promise((resolve, reject) => {
          this.dependencies.cities.splice(0)
          if (query !== '') {
            this.isSearchingCity = true
            let data = {
              query
            }
            restfulService.post('city', 'search', null, data)
              .then((response) => {
                this.dependencies.cities.splice(0)
                this.dependencies.cities = [...this.dependencies.cities, ...response]
                this.isSearchingCity = false
                resolve()
              })
              .catch(e => {
                console.log(e)
                reject()
              })
          }
        })
      },
      /**
       * Retorna a etapa na inscrição
       * Passa os dados preenchidos via props para serem recuperados na etapa
       */
      onPrevious () {
        let data = cloneDeep(this.registration)
        data.physicalData.data = cloneDeep(this.data)
        this.$router.push({name: 'registration.store.personal', params: {registration: data}})
      },
      /**
       * Avança uma etapa na inscrição
       * Passa os dados preenchidos via props para serem recuperados na etapa
       */
      onSaveData () {
        let data = cloneDeep(this.registration)
        data.physicalData.data = cloneDeep(this.data)
        this.$router.push({name: 'registration.store.event', params: {registration: data}})
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">
        <div class="forms form-registration">
            <div class="buttons-center">
                <el-button type="default"
                           size="large"
                           @click="onPrevious()">
                    <i class="fa fa-arrow-left"></i>
                    <span>Voltar</span>
                </el-button>
            </div>
            <el-form :model="data"
                     label-position="top">
                <h3 class="title-separator">Seus dados</h3>
                <div class="completed-data">
                    <table class="table-confirmation">
                        <tbody>
                        <tr>
                            <td width="50%">
                                <strong>Nome:</strong> {{registration.personalData.data.nome}}
                            </td>
                            <td width="50%">
                                <strong>Email:</strong> {{registration.personalData.data.email}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <h3 class="title-separator">Informações pessoais</h3>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Data de Nascimento"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.dt_nascimento.$error }">
                            <el-date-picker v-model="data.dt_nascimento"
                                            key="physicalDatadt_nascimento"
                                            type="date"
                                            format="dd/MM/yyyy"
                                            value-format="yyyy-MM-dd"
                                            v-mask="'##/##/####'"
                                            placeholder="Data de Nascimento"
                                            @input="$v.data.dt_nascimento.$touch()">
                            </el-date-picker>
                            <validation-message v-if="$v.data.dt_nascimento.$error"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Sexo">
                            <el-radio class="radio" v-model="data.sexo" :label="'M'">Masculino</el-radio>
                            <el-radio class="radio" v-model="data.sexo" :label="'F'">Feminino</el-radio>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="CPF"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.cpf.$error }">
                            <el-input v-model="data.cpf"
                                      key="physicalDataCpf"
                                      v-mask="'###.###.###-##'"
                                      @input="$v.data.cpf.$touch()"/>
                            <validation-message v-if="$v.data.cpf.$error"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Filiação 1 (Mãe)"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.nome_mae.$error }">
                            <el-input v-model="data.nome_mae"
                                      @input="$v.data.nome_mae.$touch()"/>
                            <validation-message v-if="$v.data.nome_mae.$error"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="RG"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.rg_numero.$error }">
                            <el-input v-model="data.rg_numero"
                                      @input="$v.data.rg_numero.$touch()"/>
                            <validation-message v-if="$v.data.rg_numero.$error"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Filiação 2">
                            <el-input v-model="data.nome_pai"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Celular"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.fone_celular.$error }">
                            <el-input v-model="data.fone_celular"
                                      key="physicalDatafone_celular"
                                      v-mask="['(##) ####.####', '(##) #####.####']"
                                      @input="$v.data.fone_celular.$touch()"/>
                            <validation-message v-if="$v.data.fone_celular.$error"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Necessidades Especiais">
                            <el-select v-model="data.necessidades_especiais"
                                       filterable
                                       multiple
                                       placeholder="Selecione uma opção"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full">
                                <el-option
                                        v-for="item in dependencies.special_needs"
                                        :key="item.id"
                                        :label="item.description"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Telefone Fixo">
                            <el-input v-model="data.fone_residencial"
                                      key="physicalDatafone_residencial"
                                      v-mask="['(##) ####.####', '(##) #####.####']"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Etnia">
                            <el-select v-model="data.ref_raca"
                                       filterable
                                       clearable
                                       placeholder="Selecione uma Etnia"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full">
                                <el-option
                                        v-for="item in dependencies.ethnicities"
                                        :key="item.id"
                                        :label="item.description"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Telefone para Recado">
                            <el-input v-model="data.fone_recado"
                                      key="physicalDatafone_recado"
                                      v-mask="['(##) ####.####', '(##) #####.####']"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Estado Civil">
                            <el-select v-model="data.ref_estado_civil"
                                       filterable
                                       clearable
                                       placeholder="Selecione um Estado Civil"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full">
                                <el-option
                                        v-for="item in dependencies.marital_status"
                                        :key="item.id"
                                        :label="item.description"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Naturalidade">
                            <el-select v-model="data.ref_naturalidade"
                                       clearable
                                       filterable
                                       remote
                                       :remote-method="onSearchCity"
                                       :loading="isSearchingCity"
                                       placeholder="Digite o nome da cidade"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full">
                                <el-option
                                        v-for="item in dependencies.cities"
                                        :key="item.id"
                                        :label="item.name + ' / ' + item.state.uf"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Nacionalidade"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.ref_nacionalidade.$error }">
                            <el-select v-model="data.ref_nacionalidade"
                                       filterable
                                       clearable
                                       placeholder="Selecione uma Nacionalidade"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full"
                                       @input="$v.data.ref_nacionalidade.$touch()">
                                <el-option
                                        v-for="item in dependencies.countries"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <validation-message
                                    v-if="$v.data.ref_nacionalidade.$error"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="Link Curriculo Lattes">
                            <el-input v-model="data.link"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div v-if="isOverEighteen">
                    <h3 class="title-separator">Informações de cobrança</h3>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Nome do Responsável"
                                          class="is-required"
                                          v-bind:class="{ 'el-form-item--error': $v.data.ec_nome.$error }">
                                <el-input v-model="data.ec_nome"
                                          @input="$v.data.ec_nome.$touch()"/>
                                <validation-message v-if="$v.data.ec_nome.$error"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="CPF do Responsável"
                                          class="is-required"
                                          v-bind:class="{ 'el-form-item--error': $v.data.ec_cpf_cnpj.$error }">
                                <el-input v-model="data.ec_cpf_cnpj"
                                          key="physicalDataCpf"
                                          v-mask="'###.###.###-##'"
                                          @input="$v.data.ec_cpf_cnpj.$touch()"/>
                                <validation-message v-if="$v.data.ec_cpf_cnpj.$error"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="CEP"
                                          class="is-required"
                                          v-bind:class="{ 'el-form-item--error': $v.data.ec_cep.$error }">
                                <el-input v-model="data.ec_cep"
                                          @input="$v.data.ec_cep.$touch()"
                                          key="physicalDataCep"
                                          v-mask="'#####-###'"/>
                                <validation-message v-if="$v.data.ec_cep.$error"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Cidade"
                                          class="is-required"
                                          v-bind:class="{ 'el-form-item--error': $v.data.ec_ref_cidade.$error }">
                                <el-select v-model="data.ec_ref_cidade"
                                           clearable
                                           filterable
                                           remote
                                           :remote-method="onSearchCity"
                                           :loading="isSearchingCity"
                                           placeholder="Digite o nome da cidade"
                                           empty-text="Nenhum registro encontrado"
                                           class="el-select-full"
                                           @input="$v.data.ec_ref_cidade.$touch()">
                                    <el-option
                                            v-for="item in dependencies.cities"
                                            :key="item.id"
                                            :label="item.name + ' / ' + item.state.uf"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                <validation-message v-if="$v.data.ec_ref_cidade.$error"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Rua"
                                          class="is-required"
                                          v-bind:class="{ 'el-form-item--error': $v.data.ec_rua.$error }">
                                <el-input v-model="data.ec_rua"
                                          @input="$v.data.ec_rua.$touch()"/>
                                <validation-message
                                        v-if="$v.data.ec_rua.$error"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Número"
                                          class="is-required"
                                          v-bind:class="{ 'el-form-item--error': $v.data.ec_numero.$error }">
                                <el-input v-model="data.ec_numero"
                                          ref="physicalDataNumero"
                                          @input="$v.data.ec_numero.$touch()"/>
                                <validation-message
                                        v-if="$v.data.ec_numero.$error"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Bairro"
                                          class="is-required"
                                          v-bind:class="{ 'el-form-item--error': $v.data.ec_bairro.$error }">
                                <el-input v-model="data.ec_bairro"
                                          @input="$v.data.ec_bairro.$touch()"/>
                                <validation-message
                                        v-if="$v.data.ec_bairro.$error"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Complemento">
                                <el-input v-model="data.ec_complemento"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <el-form-item class="buttons-save">
                    <el-button type="primary"
                               size="large"
                               @click="onSaveData"
                               :disabled="isSubmitted || $v.data.$invalid">
                        <i class="fa fa-arrow-right"></i>
                        <span>Salvar e Avançar</span>
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
